import React from "react";
import { useLang } from "../context/LanguageContext";

const MAP = {
  now: { label: "available_now", cls: "bg-emerald-50 text-emerald-700 border-emerald-200", live: true },
  week: { label: "available_week", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  date: { label: "available_date", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  none: { label: "not_available", cls: "bg-slate-100 text-slate-600 border-slate-200" },
};

export function AvailabilityBadge({ status = "none", size = "sm", testid }) {
  const { t } = useLang();
  const m = MAP[status] || MAP.none;
  const pad = size === "lg" ? "px-3 py-1.5 text-xs" : "px-2.5 py-1 text-[11px]";
  return (
    <span
      data-testid={testid || `availability-badge-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-full border font-semibold uppercase tracking-wide ${pad} ${m.cls}`}
    >
      {m.live && <span className="live-dot" />}
      {t(m.label)}
    </span>
  );
}
